import { getRoadmapPromoted } from '@/voc/api/roadmaps.api';

const state = {
    promises: {},
};

const mutations = {};

const actions = {
    async loadActiveItemPromotedRoadmapItems ({ commit }, { vocItemId }) {
        try {
            const roadmapPromoted = await getRoadmapPromoted({ vocItemId });
            commit('vocItems/setActiveItemPromotedRoadmapItems', roadmapPromoted, { root: true });
        } catch (error) {
            commit('vocItems/setError', { error }, { root: true });
            throw error;
        }
    },
    addActiveItemPromotedRoadmapItem ({ commit, rootGetters }, promotedRoadmapItem) {
        const activeItemPromotedRoadmapItems = [
            ...rootGetters['vocItems/activeItemPromotedRoadmapItems'],
            promotedRoadmapItem,
        ];
        commit('vocItems/setActiveItemPromotedRoadmapItems', activeItemPromotedRoadmapItems, { root: true });
    },
    fetchRoadmapItems ({ dispatch }, { items }) {
        return dispatch('roadmaps/items/loadMany', { items }, { root: true });
    },
};

const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
